import { Typography } from '@mui/material';

const SectionHeader = ({ title = '' }) => {
  return (
    <Typography
      component="h2"
      sx={{ flexGrow: 1, color: 'black', fontWeight: 700, fontSize: '1.5rem', my: '1rem' }}
    >
      {title}
    </Typography>
  );
};

export default SectionHeader;
